import * as Stimulus from "@hotwired/stimulus"

/**
 * Enables toggling visibility of dropdown container within parent control.
 */
export class DropdownMenuController extends Stimulus.Controller {
    static values = {
        selector: String
    }

    static get targets() {
        return [ "menu", "controlOpen", "controlClose" ]
    }

    static classes = [ "hidden" ];

    connect() {
        DEV: this.#assertConfiguration();
    }

    toggle() {
        DEV: this.#assertConfiguration();

        this.menuTargets.forEach((el, i) => {
            el.classList.toggle(this.hiddenClass);
        });

        this.toggleOpen();
    }

    hide(e) {
        DEV: this.#assertConfiguration();

        if (this.hasSelectorValue && e.target.closest(this.selectorValue)) {
            return;
        }

        this.menuTargets.forEach((el, i) => {
            el.classList.add(this.hiddenClass);
        });

        this.showOpen();
    }

    showOpen() {
        this.controlOpenTarget.classList.remove(this.hiddenClass);
        this.controlCloseTarget.classList.add(this.hiddenClass);
    }

    toggleOpen() {
        this.controlOpenTarget.classList.toggle(this.hiddenClass);
        this.controlCloseTarget.classList.toggle(this.hiddenClass);
    }

    #assertConfiguration() {
        if(!this.hasSelectorValue) {
            throw new Error('[DropdownMenuController] Missing attribute: data-dropdown-menu-selector-value')
        }
        if(!this.hasHiddenClass) {
            throw new Error('[DropdownMenuController] Missing attribute: data-dropdown-menu-hidden-class')
        }
    }
};
